// extracted by mini-css-extract-plugin
export var content = "_d7-3";
export var list = "_d7-4";
export var settingsContent = "_d7-7";
export var settingsPanel = "_d7-8";
export var state = "_d7-6";
export var triggerBadge = "_d7-2";
export var triggerButton = "_d7-1";
export var triggerShell = "_d7-0";
export var unreadDot = "_d7-5";